import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/node_modules/react-hot-toast/dist/index.mjs");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/globals.css");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/components/SentryInit.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/lib/i18n/I18nProvider.tsx")